module.exports = __webpack_public_path__ + "static/media/british_airways_logo.8e2f117e.png";